import "./AssetManagerTemplate.css";

import React from "react";

import { SeedActiveElement } from "../../models";
import { SeedFooter, SeedNavigation } from "../../widget";

export interface AssetManagerTemplateProps {
  children: React.ReactNode;
  activeElement?: SeedActiveElement;
  fullHeight?: boolean;
  fullWidth?: boolean;
}

export const AssetManagerTemplate = ({
  activeElement,
  children,
  fullHeight = false,
  fullWidth = false,
}: AssetManagerTemplateProps): JSX.Element => {
  return (
    <div className={`AssetManagerScreen${fullHeight ? " AssetManagerScreen_fullHeight" : ""}`}>
      <SeedNavigation activeElement={activeElement} />
      <div
        className={`AssetManagerContainer${fullHeight ? " AssetManagerContainer_fullHeight" : ""}${
          fullWidth ? " AssetManagerContainer_fullWidth" : ""
        }`}
      >
        {children} <SeedFooter />
      </div>
    </div>
  );
};
